import { ReactNode, createElement } from "react";

export const employeeToTitleCase = (s: string) =>
  s
    ?.replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const employeeIsRecord = (v: unknown): v is Record<string, unknown> =>
  !!v && typeof v === "object" && !Array.isArray(v);

export const employeeFormatValueDefault = (v: unknown): ReactNode => {
  if (v == null) return createElement("em", { className: "text-muted" }, "—");
  if (typeof v === "boolean") return v ? "Yes" : "No";
  if (v instanceof Date) return v.toISOString().slice(0, 10);
  if (Array.isArray(v)) {
    return v.length
      ? v.join(", ")
      : createElement("em", { className: "text-muted" }, "—");
  }
  if (employeeIsRecord(v)) {
    return createElement(
      "code",
      { className: "text-muted" },
      JSON.stringify(v, null, 2)
    );
  }
  return String(v);
};
